import { render, staticRenderFns } from "./copyService.vue?vue&type=template&id=42c1c8a5&scoped=true&"
import script from "./copyService.vue?vue&type=script&lang=js&"
export * from "./copyService.vue?vue&type=script&lang=js&"
import style0 from "./copyService.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./copyService.vue?vue&type=style&index=1&id=42c1c8a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c1c8a5",
  null
  
)

component.options.__file = "copyService.vue"
export default component.exports